module.exports = __webpack_public_path__ + "static/media/AdvancedGuidePic.19babc6b.png";